import React from 'react';
import useContext from '../../../hooks/useContext';
import { CategoryContext } from './Providers/CategoryProvider';
import RegularFilters from './Filters/RegularFilters';
import Distance from '../../../styled/Distance';
import {
  FilterDivider,
  LeadTimeWrapper,
  ProductGridWrapper,
  ProductViewWrapper,
} from '../../../styled/Filters/wrappers';
import LeadtimeFilter from './Filters/LeadtimeFilter';
import ProductImageFilter from '../../../components-legacy/ProductViewSettings/ProductImageFilter';
import GridFilter from '../../../components-legacy/ProductViewSettings/GridView';
import Text from '../../../styled/Text';

export default function ViewSettings({ showFilters = true }: { showFilters?: boolean }) {
  const { totalHits } = useContext(CategoryContext);

  return (
    <>
      {showFilters && <RegularFilters />}
      <Distance size="4" />
      <FilterDivider>
        {showFilters && (
          <LeadTimeWrapper>
            <LeadtimeFilter />
          </LeadTimeWrapper>
        )}
        <ProductViewWrapper>
          <ProductGridWrapper>
            <Text tone="ghost">
              {totalHits === 1 ? `${totalHits} produkt` : `${totalHits} produkter`}
            </Text>
            <ProductImageFilter />
          </ProductGridWrapper>
          <GridFilter />
        </ProductViewWrapper>
      </FilterDivider>
    </>
  );
}
